import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  invitedToJoin: {
    id: 'portal.views.joinCohort.invitedToJoin',
    defaultMessage: 'You’ve been invited to join',
    description: 'Eyebrow above the cohort name on the invite card',
  },
  courseLabel: {
    id: 'portal.views.joinCohort.courseLabel',
    defaultMessage: 'Course',
    description: 'Label for the course row in the invite card',
  },
  courseName: {
    id: 'portal.views.joinCohort.courseName',
    defaultMessage: 'Leading with Character',
    description: 'Name of the leadership program every cohort belongs to, shown as the course on the invite card',
  },
  facilitatorLabel: {
    id: 'portal.views.joinCohort.facilitatorLabel',
    defaultMessage: 'Facilitator',
    description: 'Label for the facilitator row in the invite card',
  },
  membersLabel: {
    id: 'portal.views.joinCohort.membersLabel',
    defaultMessage: 'Members',
    description: 'Label for the member-count row in the invite card',
  },
  memberCountLabel: {
    id: 'portal.views.joinCohort.memberCount',
    defaultMessage: '{count} {count, plural, one {member} other {members}}',
    description: 'Member count on the invite card, {count} is a number',
  },
  languageLabel: {
    id: 'portal.views.joinCohort.languageLabel',
    defaultMessage: 'Language',
    description: 'Label for the cohort programme-language row in the invite card, shown to every '
      + 'visitor regardless of whether they can join',
  },
  forumBlurb: {
    id: 'portal.views.joinCohort.forumBlurb',
    defaultMessage: 'By joining, you’ll get access to a <b>private group forum</b> where your cohort can discuss the course together.',
    description: 'Value-proposition text on the invite card; <b> wraps the emphasized phrase',
  },
  goBackButton: {
    id: 'portal.views.joinCohort.goBackButton',
    defaultMessage: 'Go back',
    description: 'Secondary button that returns to the previous page from the invite card',
  },
  notFoundMessage: {
    id: 'portal.views.joinCohort.notFound',
    defaultMessage: 'We couldn’t find this invite. The link may be incorrect or the cohort may no longer be active.',
    description: 'Message shown for an unknown or inactive invite slug',
  },
  loadErrorMessage: {
    id: 'portal.views.joinCohort.loadError',
    defaultMessage: 'We couldn’t load this invite. Please try again.',
    description: 'Message shown when the invite request fails for a reason other than an unknown slug (server error or network failure)',
  },
  anonymousMessage: {
    id: 'portal.views.joinCohort.anonymousMessage',
    defaultMessage: 'Log in or register to join this cohort — you’ll be enrolled in its courses automatically.',
    description: 'Message shown to an anonymous visitor on the join page',
  },
  loginButton: {
    id: 'portal.views.joinCohort.loginButton',
    defaultMessage: 'Log In',
    description: 'Log in button on the join page',
  },
  registerButton: {
    id: 'portal.views.joinCohort.registerButton',
    defaultMessage: 'Register',
    description: 'Register button on the join page',
  },
  joinButton: {
    id: 'portal.views.joinCohort.joinButton',
    defaultMessage: 'Join This Cohort',
    description: 'Join This Cohort button for an authenticated visitor',
  },
  joiningButton: {
    id: 'portal.views.joinCohort.joiningButton',
    defaultMessage: 'Joining…',
    description: 'Join This Cohort button while the request is pending',
  },
  joinError: {
    id: 'portal.views.joinCohort.joinError',
    defaultMessage: 'We could not join you to this cohort. Please try again.',
    description: 'Generic error message when joining a cohort fails',
  },
  languageMismatchMessage: {
    id: 'portal.views.joinCohort.languageMismatchMessage',
    defaultMessage: 'This cohort runs in {language}, but your account language is different, so '
      + 'you can’t join it.',
    description: 'Explains why Join is unavailable, shown when the server reports the viewer '
      + 'cannot join this cohort (eligibility check) and as the backstop for a 403 '
      + 'language_mismatch join refusal; {language} is the cohort’s programme language shown in '
      + 'the visitor’s own language',
  },
});

export default messages;
